import React, { useState } from 'react';

// Dummy data
const dummyStats = [
  { label: 'Startups Connected', value: '10K+' },
  { label: 'MSME Connected', value: '50K+' },
  { label: 'Boutique Advisors', value: '500+' },
  { label: 'Funds Raised', value: '₹500 Cr+' },
  { label: 'Partners', value: '50+' },
  { label: 'Success Rate', value: '85%' }
];

const dummyTestimonials = [
  {
    name: 'Priya Sharma',
    role: 'Founder, EcoTech Startup',
    quote: 'FundLanes transformed our funding journey with transparent matchmaking and quick liquidity via FlashLane.',
    avatar: 'https://via.placeholder.com/60'
  },
  {
    name: 'Raj Patel',
    role: 'Angel Investor',
    quote: 'The Founder Transparency Hub cut our due diligence time by 70%. Ethical and efficient!',
    avatar: 'https://via.placeholder.com/60'
  },
  {
    name: 'Amit Kumar',
    role: 'MSME Owner',
    quote: 'Got instant micro-funding for payroll—FlashLane saved our operations during a crunch.',
    avatar: 'https://via.placeholder.com/60'
  }
];

const dummyFeatures = [
  {
    icon: '🧠',
    title: '5Whys Intelligence',
    desc: 'Root-cause driven insights before, during & after funding.'
  },
  {
    icon: '⚡',
    title: 'FlashLane',
    desc: 'Short-term AI-curated microfunding for emergency gaps.'
  },
  {
    icon: '🤝',
    title: 'Trust-Based Marketplace',
    desc: 'Verified players, transparent histories, ethical checks.'
  },
  {
    icon: '🏢',
    title: 'Full Ecosystem Coverage',
    desc: 'Founders, Investors, Lenders, Services, Crowdfunding—all in one.'
  },
  {
    icon: '🌐',
    title: 'Global-by-Design',
    desc: 'India-first, regulatory-compliant, scalable worldwide.'
  }
];

const dummyChallenges = [
  { challenge: 'Fragmented funding landscape', edge: 'Unified AI marketplace linking all stakeholders' },
  { challenge: 'Long, opaque funding cycles', edge: 'Real-time matchmaking, risk profiling & transparency' },
  { challenge: 'Lack of trust', edge: 'Verified profiles, AI credibility scoring & dashboards' },
  { challenge: 'Absence of micro short-term funding', edge: 'FlashLane offers instant bridge connections' },
  { challenge: 'Poor financial literacy', edge: 'Built-in Startup Literacy, AI Counsellor & Ethics Navigator' }
];

const dummyModules = [
  {
    title: 'Founder Transparency Hub',
    desc: 'Living cap table, operational metrics, docs vault with selective access.',
    icon: '🔓'
  },
  {
    title: 'Funding Marketplace',
    desc: 'ML-matched deals by stage, sector, risk—deal rooms & e-sign.',
    icon: '💼'
  },
  {
    title: 'Lending & Debt Hub',
    desc: 'Micro-loans to revenue-share; automated underwriting & servicing.',
    icon: '🏦'
  },
  {
    title: 'Crowdfunding Suite',
    desc: 'Donation/reward/equity campaigns with escrow & social sharing.',
    icon: '📈'
  },
  {
    title: 'Service Marketplace',
    desc: 'Co-working, legal, HR—book, bundle with funding.',
    icon: '🛠️'
  },
  {
    title: 'Risk Watchlist',
    desc: 'Monitor high-risk startups, MSMEs, investors, advisors, and partners for proactive alerts and compliance.',
    icon: '⚠️'
  }
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="bg-gray-900 shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-yellow-200">FundLanes</h1>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              <a href="#home" className="text-white hover:text-indigo-600 px-3 py-2">Home</a>
              <a href="#features" className="text-white hover:text-indigo-600 px-3 py-2">Features</a>
              <a href="#about" className="text-white hover:text-indigo-600 px-3 py-2">About</a>
              <a href="#contact" className="text-white hover:text-indigo-600 px-3 py-2">Contact</a>
              <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">Sign Up</button>
            </div>
          </div>
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-white">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden bg-gray-900 border-t">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a href="#home" className="block text-white hover:text-indigo-600 px-3 py-2">Home</a>
            <a href="#features" className="block text-white hover:text-indigo-600 px-3 py-2">Features</a>
            <a href="#about" className="block text-white hover:text-indigo-600 px-3 py-2">About</a>
            <a href="#contact" className="block text-white hover:text-indigo-600 px-3 py-2">Contact</a>
            <button className="w-full bg-indigo-600 text-white px-4 py-2 rounded-md mt-2">Sign Up</button>
          </div>
        </div>
      )}
    </nav>
  );
};

const Hero = () => (
  <section id="home" className="pt-16 pb-12 bg-gradient-to-r from-indigo-600 to-purple-700 text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h1 className="text-xl sm:text-xl lg:text-2xl font-bold mb-4 mt-4">Where Capital Meets Clarity</h1>
      <p className="text-sm sm:text-lg mb-2">Transforming funding into a transparent, AI-enabled journey of trust for startups, MSMEs, investors and more.</p>
      <p className="text-sm sm:text-lg text-yellow-200 mb-4">For startups requiring up to ₹1 crore in working capital funding. For micro angel investors committing up to ₹1 lakh.</p>
      <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-4">
        <button className="border-2 border-white text-white px-6 py-3 rounded-md font-semibold hover:bg-gray-800 hover:text-indigo-600">Boost SAKSHAM Score</button>
        <button className="border-2 border-white text-white px-6 py-3 rounded-md font-semibold hover:bg-gray-900 hover:text-indigo-600">Essential Literacy Kit</button>
        <button className="bg-gray-900 text-indigo-600 px-6 py-3 rounded-md font-semibold hover:bg-gray-900 hover:text-indigo-600">Get Started</button>
        <button className="border-2 border-white text-white px-6 py-3 rounded-md font-semibold hover:bg-gray-900 hover:text-indigo-600">Learn More</button>
      </div>
    </div>
  </section>
);

const Stats = () => (
  <section className="py-4 bg-gray-600">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-3 md:grid-cols-6 gap-8 text-center">
        {dummyStats.map((stat, idx) => (
          <div key={idx}>
            <p className="text-yellow-200 text-xl sm:text-3xl font-bold">{stat.value}</p>
            <p className="text-white text-m">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const WhyFundLanes = () => (
  <section id="features" className="py-4 bg-gray-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-xl font-bold text-center mb-4">Why FundLanes?</h2>
      <div className="overflow-x-auto text-sm">
        <table className="min-w-full table-auto border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-800">
              <th className="border border-gray-300 px-4 py-2 text-left">Challenge</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Our Edge</th>
            </tr>
          </thead>
          <tbody>
            {dummyChallenges.map((item, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-800' : 'bg-gray-600'}>
                <td className="border border-gray-300 px-4 py-2">{item.challenge}</td>
                <td className="border border-gray-300 px-4 py-2">{item.edge}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

const Differentiators = () => (
  <section className="py-4 bg-gray-600">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-xl font-bold text-center mb-4">Unique Differentiators</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {dummyFeatures.map((feature, idx) => (
          <div key={idx} className="bg-gray-800 p-6 rounded-lg shadow-md text-center">
            <div className="text-2xl mb-4">{feature.icon}</div>
            <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
            <p className="text-white text-sm">{feature.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const ModulesShowcase = () => (
  <section className="py-4 bg-gray-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-xl font-bold text-center mb-4">Core Modules</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {dummyModules.map((module, idx) => (
          <div key={idx} className="bg-gray-600 p-6 rounded-lg text-center">
            <div className="text-lg mb-4">{module.icon}</div>
            <h3 className="text-sm font-semibold mb-2">{module.title}</h3>
            <p className="text-white text-xs">{module.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const FlashLaneSection = () => (
  <section className="py-4 bg-gradient-to-r from-purple-600 to-indigo-700 text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-xl font-bold mb-4">Introducing FlashLane</h2>
      <p className="text-lg mb-8">Instant micro-bridge funding for liquidity crunches—₹10K–₹2L in 1–7 days, powered by AI scoring and partners.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        <div>
          <h3 className="text-lg text-left font-semibold mb-4">Key Benefits</h3>
          <ul className="text-left space-y-2">
            <li>• AI Fraud Guards & Root-Cause Coaching</li>
            <li>• Partner NBFCs/P2P Integration</li>
            <li>• Auto-Repayment & Credibility Badges</li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg text-left font-semibold mb-4">How It Works</h3>
          <ol className="text-left space-y-2 list-decimal pl-4">
            <li>Submit need via app</li>
            <li>AI scores & matches</li>
            <li>Get funds in hours</li>
          </ol>
        </div>
      </div>
      <button className="bg-gray-800 text-purple-600 px-6 py-3 rounded-md font-semibold hover:bg-gray-800">Try FlashLane</button>
    </div>
  </section>
);

const Testimonials = () => (
  <section className="py-4 bg-gray-600">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-xl font-bold text-center mb-4">What Our Users Say</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {dummyTestimonials.map((testimonial, idx) => (
          <div key={idx} className="bg-gray-800 p-6 rounded-lg shadow-md">
            <img src={testimonial.avatar} alt={testimonial.name} className="text-white w-16 h-16 rounded-full mx-auto mb-4" />
            <p className="text-white italic mb-4">"{testimonial.quote}"</p>
            <h3 className="font-semibold">{testimonial.name}</h3>
            <p className="text-white">{testimonial.role}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const CTA = () => (
  <section className="py-4 bg-indigo-600 text-white text-center">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-xl font-bold mb-4">Ready to Fuel Your Growth?</h2>
      <p className="text-lg mb-8">Join the trusted funding ecosystem today.</p>
      <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 max-w-md mx-auto">
        <button className="bg-gray-800 text-indigo-600 w-40 px-6 py-3 rounded-md font-semibold hover:bg-gray-800">Sign Up Free</button>
        <button className="border-2 border-white text-white px-6 py-3 w-40 rounded-md font-semibold hover:bg-gray-800 hover:text-indigo-600">Contact Us</button>
      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer id="contact" className="bg-gray-800 text-white py-4">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-xl font-bold mb-4">FundLanes</h3>
          <p>Powered by Think5Whys Global DeepTech Solutions, Mumbai, India.</p>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Modules</h4>
          <ul className="space-y-2">
            <li><a href="#" className="text-gray-300 hover:text-white">Transparency Hub</a></li>
            <li><a href="#" className="text-gray-300 hover:text-white">Funding Marketplace</a></li>
            <li><a href="#" className="text-gray-300 hover:text-white">FlashLane</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Company</h4>
          <ul className="space-y-2">
            <li><a href="#" className="text-gray-300 hover:text-white">About</a></li>
            <li><a href="#" className="text-gray-300 hover:text-white">Vision</a></li>
            <li><a href="#" className="text-gray-300 hover:text-white">Careers</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Connect</h4>
          <p>hello@fundlanes.com | +91-22-XXXXXXX</p>
          <div className="flex space-x-4 mt-4 text-center">
            <a href="#" className="text-gray-300 hover:text-white">Twitter</a>
            <a href="#" className="text-gray-300 hover:text-white">LinkedIn</a>
            <a href="#" className="text-gray-300 hover:text-white">Email</a>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
        <p>&copy; 2026 Think5Whys Global DeepTech Solutions.</p>
      </div>
    </div>
  </footer>
);

const FundLanesHome = () => {
  return (
    <div className="min-h-screen bg-gray-900 [&_p]:text-white [&_h3]:text-white [&_li]:text-white">
      <Navbar />
      <Hero />
      <Stats />
      <WhyFundLanes />
      <Differentiators />
      <ModulesShowcase />
      <FlashLaneSection />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
};

export default FundLanesHome;